'use strict';

const libPictView = require('pict-view');
const libShared = require('./ProjectContractTypes-Shared.js');

/**
 * ProjectTypes — the #/ProjectTypes management screen. A thin view over the shared ProjectContractTypes provider
 * (activated in Project mode). Logic/state live in the provider; this view just lays out the rail/detail shell.
 */
class ProjectTypes extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);
		/** @type {any} */
		this.pict;
	}

	get provider() { return this.pict.providers.ProjectContractTypes; }

	onAfterRender(pRenderable)
	{
		this.pict.CSSMap.injectCSS();
		const tmpProvider = this.provider;
		if (tmpProvider) { tmpProvider.activate('Project'); }
		return super.onAfterRender(pRenderable);
	}
}

module.exports = ProjectTypes;
module.exports.default_configuration =
{
	ViewIdentifier: 'ProjectTypes',
	DefaultRenderable: 'ProjectTypesWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	CSS: libShared.CSS,
	Templates:
	[
		{
			Hash: 'ProjectTypes-Wrap',
			Template: libShared.wrapTemplate('Project Types', 'Create and edit project types, then set up each one’s template — statuses, default dates, observation types, labels and more — that new projects are cloned from.'),
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'ProjectTypesWrap',
			TemplateHash: 'ProjectTypes-Wrap',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
			RenderMethod: 'replace',
		},
	],
};
